<script setup>
import Header from "@/components/base/Header.vue";
import Button from "@/components/base/Button.vue";
import { handleAnchorClick } from "@/utils/scrollToAnchor";
</script>

<template>
  <section class="welcome relative">
    <Header/>
    <div class="welcome__content relative">
      <h1 class="text-main" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700">Enter the World of Galazia</h1>
      <p class="text-m" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700" :delay="200">Galazia is where innovation meets entertainment. We build immersive gaming experiences powered by cutting-edge technology, trusted partnerships, and a commitment to excellence. </p>
      <div class="flex align-center" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="400">
        <Button @click="handleAnchorClick('#contacts')">Get In Touch</Button>
        <Button secondary link="#about" @click="handleAnchorClick('#who-we-are')">About us</Button>
      </div>
    </div>
    <img src="../../assets/main.png" alt="section image" class="absolute"/>
    <div class="circle-pink absolute"></div>
    <div class="circle-blue absolute"></div>
    <div class="circle-pink2 absolute"></div>
  </section>
</template>

<style scoped lang="scss">
.welcome {
  padding: 4.167vw 8.333vw 0;
  & > img {
    width: 50%;
    right: 0;
    bottom: 5%;
    z-index: 1;
  }
  &__content {
    z-index: 2;
    width: 70%;
    max-width: clamp(300px, 44.444vw, 3200px);
    padding: 15vh 0 20vh;
    p {
      color: rgba(255, 255, 255, 0.70);
      width: 70%;
      margin: clamp(50px, 3.472vw, 250px) 0 clamp(40px, 2.778vw, 200px);
    }
    & > div:last-child {
      gap: clamp(15px, 1.042vw, 75px);
    }
  }
  .circle-pink, .circle-blue, .circle-pink2 {
    width: clamp(600px, 41.667vw, 3000px);
    height: clamp(600px, 41.667vw, 3000px);
    top: -30%;
    right: -15%;
    transform: rotate(0);
    z-index: 0;
  }
  .circle-blue {
    top: 45%;
    right: -10%;
  }
  .circle-pink2 {
    right: 22%;
    top: -10%;
  }
}

@media (max-width: 1024px) {
  .welcome {
    &__content {
      max-width: 100%;
    }
    & > img {
      bottom: 14%;
    }
  }
}
@media (max-width: 768px) {
  .welcome {
    padding: 30px 24px;
    &__content {
      padding: 80px 0 320px;
      width: 100%;
      p {
        width: 100%;
        margin: 39px 0 27px;
      }
      & > div:last-child {
        gap: 9px;
        max-width: 450px;
        flex-wrap: wrap;
      }
    }
    & > img {
      max-width: 400px;
      width: 90%;
      bottom: -5%;
      right: 4%;
      transform: rotate(-85deg);
    }
    .circle-pink {
      width: 407px;
      height: 407px;
      background: #413BE4;
      right: 10%;
      top: 55%;
    }
    .circle-blue {
      background: #0AFFFB;
      width: 300px;
      height: 300px;
      right: -5%;
      top: 23%;
    }
    .circle-pink2 {
      display: none;
    }
  }
}
</style>